import { Message, MessageContentDataBlank } from "../../model/message";

export default function isGroupFirst(message: Message<MessageContentDataBlank>, lastMessage?: Message<MessageContentDataBlank>) {

    // 消息在1分钟以内，并且是自己发的消息
    return !lastMessage ||
        message.owner.id !== lastMessage.owner.id ||
        message.insertedAt.add(-1, "minutes").isAfter(lastMessage.insertedAt)
}